import { z } from 'zod'

export const operatorLoginSchema = z.object({
  email: z.email('Enter a valid email address.').max(180),
  password: z.string().min(1, 'Enter your password.').max(4096),
})
export type OperatorLoginForm = z.infer<typeof operatorLoginSchema>

const optional = (max: number) => z.string().trim().max(max)

export const createSchoolSchema = z.object({
  name: z.string().trim().min(1, 'Enter the school name.').max(255),
  shortName: optional(30),
  email: z.union([z.literal(''), z.email('Enter a valid email address.').max(180)]),
  phone: optional(30),
  countryCode: z.union([
    z.literal(''),
    z.string().regex(/^[A-Z]{2}$/, 'Use a two-letter country code, e.g. FR.'),
  ]),
  currency: z.string().regex(/^[A-Z]{3}$/, 'Use a three-letter currency code, e.g. EUR.'),
  timezone: z.string().min(1, 'Choose a time zone.'),
  locale: z.enum(['fr', 'en']),
  type: z.enum(['primary', 'secondary', 'combined', 'higher', 'training']),
  adminName: z.string().trim().min(1, 'Enter the administrator’s name.').max(150),
  adminEmail: z.email('Enter a valid email address.').max(180),
  subdomain: z.union([
    z.literal(''),
    z
      .string()
      .trim()
      .toLowerCase()
      .regex(
        /^[a-z0-9][a-z0-9-]{1,38}[a-z0-9]$/,
        'Use 3 to 40 lowercase letters, digits or hyphens (not at the start or end).',
      ),
  ]),
})
export type CreateSchoolForm = z.infer<typeof createSchoolSchema>
